import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ListMessageStrings } from '@usf/list-types';
import { LIST_ACTIONS } from '@usf/ngrx-list';
import { switchMap } from 'rxjs/operators';
import { MessageHandlerService } from '../../shared/services/message/message-handler.service';

@Injectable({
  providedIn: 'root',
})
export class ClientListManagementEffects {
  /* Domain api Call Success */
  domainCallSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LIST_ACTIONS.domainCallSuccess),
      switchMap(action => {
        this.messageHandlerService.handleNewAction(action?.list?.currentAction);
        return [];
      }),
    ),
  );

  /* Domain api Call Fail */
  domainCallFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LIST_ACTIONS.domainCallFail),
      switchMap(action => {
        this.messageHandlerService.handleNewAction(action?.list?.currentAction);
        return [];
      }),
    ),
  );

  /* List Updated In Store */
  listUpdatedInStore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LIST_ACTIONS.ecomR4UpdateListsInStore, LIST_ACTIONS.updateInStore),
      switchMap(action => {
        // loop through lists, if theres a current action send it to message handler
        action?.lists?.forEach(list => {
          if (
            list?.currentAction?.message ===
            ListMessageStrings.createListSuccess
          ) {
            this.messageHandlerService.handleCreateNewListSuccess(
              list?.listKey?.listTypeId,
              list?.listKey?.listId,
            );
          } else if (list?.currentAction) {
            this.messageHandlerService.handleNewAction(list?.currentAction);
          }
        });
        return [];
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private messageHandlerService: MessageHandlerService,
  ) {}
}
